import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import {
  templatePriority,
  templateQuantity,
} from 'reducers/templates/selectors';
import { updateInReviewTemplatePriority } from 'reducers/models/actions';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  templatePriority,
  templateQuantity,
});

const priorityValue = ({
  multiplePriorities,
  multipleOption,
  templatePriority,
  quantityZero,
  notApplicable,
  isDuplicate,
}) => {
  if (quantityZero || isDuplicate) {
    return notApplicable;
  } else if (multiplePriorities) {
    return multipleOption;
  } else {
    return templatePriority;
  }
};

export const quantityZero = ({ templateQuantity }) => templateQuantity === 0;

const priorityOptions = ({
  multipleOption,
  templateQuantity,
  priorityString,
  quantityZero,
  isDuplicate,
}) => {
  const availablePriorities = [2, 3, 4, 5, multipleOption];
  if (quantityZero || isDuplicate) {
    return [
      {
        clearable: false,
        value: 'n/a',
        label: `n/a`,
        disabled: true,
      },
    ];
  }
  return availablePriorities.map(priority => {
    if (priority === multipleOption) {
      if (templateQuantity > 1) {
        return {
          clearable: false,
          value: priority,
          label: `${priority}`,
        };
      } else {
        return {
          clearable: false,
          value: priority,
          label: `${priority}`,
          disabled: true,
        };
      }
    } else {
      return {
        clearable: false,
        value: priority,
        label: `${priorityString} ${priority}`,
      };
    }
  });
};

export const onPriorityChange = ({
  templateId,
  updateInReviewTemplatePriority,
  openMultiplePriorities,
  closeMultiplePriorities,
  multipleOption,
}) => event => {
  if (event.value === multipleOption) {
    openMultiplePriorities();
  } else {
    closeMultiplePriorities();
    updateInReviewTemplatePriority(templateId, event.value);
  }
};

export default compose(
  connect(
    mapStateToProps,
    {
      updateInReviewTemplatePriority,
    },
  ),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['priorityString', 'multipleOption', 'notApplicable'],
  }),
  addProps({ quantityZero }),
  addProps({ priorityOptions, priorityValue }),
  withHandlers({ onPriorityChange }),
);
